<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Transferência - {{ courseTransfer.ALUNO }}</h1>
          <small>Curso: {{ courseTransfer.CURSO }}</small>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-divider/>
        <h3 class="tituloForm">Selecione as disciplinas que deseja transferir</h3>
        <p>Valor Total: <b>R${{ Number(valueTotal).toFixed(2) }}</b></p>
        <vs-divider/>
        <vs-row>
          <vs-table
            style="width: 100%;"
            class="pd-table"
            :data="disciplines"
            v-model="disciplinesToTransfer"
          >
            <template slot="thead">
              <th>Disciplina</th>
              <th>Valor</th>
              <th>Status</th>
              <th>Turma Destino</th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :data="discipline"
                v-for="(discipline, index) in data"
                :key="index"
              >
                <vs-td
                  >
                  {{ discipline.DISCIPLINA }} <br />
                  <small>Período: {{ discipline.DTINICIAL }} a {{ discipline.DTFINAL }}</small><br />
                  <small
                    >({{ discipline.CODTURMA }} - {{ discipline.NOMETURMA }})</small
                  >
                </vs-td
                >
                <vs-td>R${{ Number(discipline.VALORDISCIPLINA).toFixed(2) }}</vs-td>
                <vs-td
                  >{{ discipline.STATUS }}<br /><span
                    v-if="discipline.DECORRIDO != 0"
                  >
                    {{ discipline.DECORRIDO }}% decorrida</span
                  ></vs-td
                >
                <vs-td>
                  <vs-select
                    style="width:100%;"
                    placeholder="Selecione"
                    noData="Nenhum dado encontrado"
                    v-model="discipline.destinationSelected"
                    autocomplete
                  >
                    <vs-select-item
                      :value="null"
                      text="Não transferir"
                    ></vs-select-item>
                    <vs-select-item
                      v-for="destination in discipline.destinationOptions"
                      :key="destination.IDTURMADISC"
                      :value="destination"
                      :text="destination.NOMENCLATURA"
                    >
                    </vs-select-item>
                  </vs-select>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-row>
        <vs-divider/>
        <h3 class="tituloForm">Informe o motivo da transferência</h3>
        <vs-row>
          <vs-col>
            <vs-select
              v-model="movementReasonSelected"
              danger-text="Campo obrigatório."
              placeholder="Selecione"
              noData="Nenhum dado encontrado"
              width="100%"
              autocomplete
            >
              <vs-select-item
                v-for="reason in movementReasons"
                :key="reason.CODMOTIVO"
                :value="reason.CODMOTIVO"
                :text="reason.DESCRICAO"
              >
              </vs-select-item>
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-button
            icon="check_circle"
            style="width: 100%;margin-top: 10px;"
            @click="goTo()"
            color="#139B0E"
            type="filled"
            :disabled="!movementReasonSelected"
          >
            Avançar
          </vs-button>
        </vs-row>
      </section>
    </div>
  </div>
</template>

<script>
import AcademicMovement from "../services/academicMovements";
//import moment from "moment";
import { getStepsInformation, updateStepsInformation } from "../helpers";

export default {
  name: "TransfersStep2",
  data: () => ({
    disciplines: [],
    movementReasons: null,
    movementReasonSelected: null,
    disciplinesToTransfer: [],
    error: null,
    courseTransfer: null,
    offers: [],
  }),
  computed: {
    valueTotal() {
      return this.disciplines.reduce((a, b) => {
        return a - -b.VALORDISCIPLINA;
      }, 0);
    },
  },
  created() {
    const stepsData = getStepsInformation();
    this.courseTransfer = stepsData.courseTransfer;

    new AcademicMovement()
      .getMovementReasons(this.courseTransfer.CODTIPOCURSO)
      .then(({ data }) => {
        this.movementReasons = Array.isArray(data) ? data : [data];
      })
      .catch(({ error }) => {
        this.error = error;
      });

    this.$vs.loading({
      color: "danger",
    });

    new AcademicMovement()
      .getDisciplines(
        this.courseTransfer.RA,
        this.courseTransfer.IDHABILITACAOFILIAL,
        this.courseTransfer.IDPERLET
      )
      .then(({ data }) => {
        this.disciplines = Array.isArray(data) ? data : [data];
        this.disciplines.map((discipline) => {
          discipline.destinationOptions = this.getDestinationOptions(
            discipline,
            this.courseTransfer.IDHABILITACAOFILIAL,
            this.courseTransfer.sameBranchAndShift
          );
        });
      })
      .catch(({ error }) => {
        this.error = error;
      })
      .finally(() => {
        this.$vs.loading.close();
      });
  },
  methods: {
    async getDestinationOptions(
      discipline,
      qualificationId,
      sameBranchAndShift
    ) {
      let destinationOptions = [];
      new AcademicMovement()
        .getDestinationOptions(
          discipline.IDTURMADISC,
          qualificationId,
          sameBranchAndShift
        )
        .then(({ data }) => {
          destinationOptions = Array.isArray(data) ? data : [data];
          discipline.destinationOptions = destinationOptions;
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          return destinationOptions;
        });
    },
    goTo() {
      const disciplines = this.disciplines;
      const movementReasonSelected = this.movementReasonSelected;
      updateStepsInformation({ disciplines });
      updateStepsInformation({ movementReasonSelected });
      this.$router.push("/transfersResume");
    },
  },
};
</script>
<style scoped>
</style>
